export enum SlaPriorityEnum {
  high = 'HIGH',
  medium = 'MEDIUM',
  low = 'LOW',
}
